'use strict';
require('react-responsive-carousel/lib/styles/carousel.css')

import React from 'react';
import { Carousel } from 'react-responsive-carousel'

class VideoBoxItems extends React.Component {

//var c=document.getElementById("myCanvas");
// var ctx=c.getContext("2d");
// var img=document.getElementById("scream");
// ctx.drawImage('http://affine.s3.amazonaws.com/thumbnail/9377894/281000',0, 0);
// var canvas = document.getElementById('myCanvas');
// var context = canvas.getContext('2d');
//
// context.beginPath();
// context.rect(88, 50, 100, 100);
//
// context.lineWidth = 3;
// context.strokeStyle = 'yellow';
// context.stroke();

  getThumbnailImageUrl (videoId, frame) {
    return `http://affine.s3.amazonaws.com/thumbnail/${videoId}/${frame}`;
  }

  // getSlickSettings () {
    // ,
    // nextArrow: <IconButton onClick={_.noop()} additionalClassName="SliderIconButtonNext" iconClass="chevronRight" />,
    // prevArrow: <IconButton onClick={_.noop()} additionalClassName="SliderIconButtonPrev" iconClass="chevronLeft" />

  // }

  render () {
    const { boxGroup, ...handlers } = this.props;
    return (
      <div  className="Thumbnail TBox">
        <div className="ThumbnailContainer TBox">
          <div style={{position: 'absolute'}}>
            <Carousel showThumbs={false} showArrows={true} >
            <div width='200' height='200'>
              <img src="http://www.protechmed.com/image/cache/data/Apron%20Colors/Nylon/BlackNylon-200x200.png" style={{maxWidth: 200+'px',maxHeight:200+'px',display: 'block', position: 'absolute'}} />
              {/*<img src="http://affine.s3.amazonaws.com/thumbnail/27521439/1015000" style={{maxWidth: 200+'px',maxHeight:200+'px',display: 'block', position: 'absolute'}} />*/}
              <svg style={{position: 'relative',maxWidth: 200+'px',maxHeight:200+'px'}}>
                <rect x="50" y="20" width="50" height="50" stroke="yellow" fill="transparent" strokeWidth="2" />
              </svg>
            </div>
            <div width='200' height='200'>
              <img src="http://affine.s3.amazonaws.com/thumbnail/27521439/1015000" style={{maxWidth: 200+'px',maxHeight:200+'px',display: 'block'}} />
            </div>
            <div width='200' height='200'>
              <img src="http://affine.s3.amazonaws.com/thumbnail/27521439/1015000" style={{maxWidth: 200+'px',maxHeight:200+'px',display: 'block'}} />
            </div>
            </Carousel>
          </div>
        </div>
        <div className="ThumbnailInfo">
          Video ID: asdss
        </div>
      </div>
    );
  }
}

export default VideoBoxItems;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/targetResults/boxResults/videoBoxItems2.component.jsx